export default __webpack_public_path__ + "static/media/aden-te-acompaña.4849314a.png";